// Should stay in sync with mddap-functions\prisma\enums\eventObservationStatus.mjs

export const EVENT_OBSERVATION_STATUS = {
  ASSIGNED: 0,
  ACCEPTED: 2,
  REJECTED: 3
};
